// Sample colors for the user's name, as are on whatsapp
export const USER_COLORS = [
    "#8393ca",
    "#6eadf5",
    "#e542a3",
    "#91ab01",
    "#e69f73",
];

export const RANDOM_INDEX = Math.floor(
    Math.random() *
        0.99 * // To ensure that this index's value is never equal to USER_COLORS.length
        USER_COLORS.length
);

export const LANDING_PAGE_URL = "exlyapp.com";
